module.exports = __webpack_public_path__ + "static/20180719_203543_optimized-4374fb34296361f06ef4ca7952829848.jpg";